import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getClubTables, getRoleInCurrentClub, getCurrentClubId, getCurrentClubPokerFrame, getPokerFrames, getGlobalClub, getCurrentAccount, getPokerFrame } from '../../../../../store/selectors';
import { PokerTable } from "./components";
import { EmptyList } from "./components";
import { useParams, useHistory } from 'react-router-dom';
import parameters from "../../../../../config/parameters";
import config from "../../../../../config/config";
import { isMobile } from 'react-device-detect';
import { alterPokerFrame } from '../../../../../store/actionCreators/club';

const gameTypes = { 'all': [], 'nlh': [1], 'plo':[2, 10, 36], 'ofc': [] };

const PokerTab = ({ isLeague }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const currClubId = useSelector(getCurrentClubId);
    const {clubId: gbClubId} = useSelector(getGlobalClub);
    const currentClubId = isLeague ? gbClubId : currClubId
    const clubPlayer = useSelector(getCurrentAccount);
    const tables = useSelector(getClubTables);
    const currentPokerFrame = useSelector(getPokerFrame);

    // const { levelExpDays } = useSelector(getCurrentClub);
    const [pokerFrameLoaded, setPokerFrameLoaded] = useState(false);
    const [pendingTableId, setPendingTableId] = useState('');
    const [tableListReady, setTableListReady] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date());
    const [selectedGameType, setSelectedGameType] = useState('all');
    const [filteredTableList, setFilteredTableList] = useState(tables);
    const roleInClub = useSelector(getRoleInCurrentClub);
    const isAdminMember = [parameters.clubRoles.OWNER, parameters.clubRoles.MANAGER].includes(roleInClub);
    const { id: clubId } = useParams();

    const initPoker = (clbId) => {
        const { username, token, } = clubPlayer;
        const frameName = `pokerClient_${clbId}`;
        const rootUrl = isMobile ? config.POKER_CLIENT_URL : config.POKER_CLIENT_URL_DESKTOP;
        let pokerUrl = `${rootUrl}?skinId=${clbId}&username=${username}&skinToken=${token}&lang=${localStorage.language}`;
        console.log('pokerUrl', pokerUrl);
        // console.log('zzz openTable: clubId:', clbId);
        dispatch(alterPokerFrame(clbId, { status: parameters.pokerLobbyStates.PENDING, wnd: window.open(pokerUrl, frameName) }));
        setPokerFrameLoaded(true);
    };

    const filterTables = () => {
        if(selectedGameType === 'all') {
            setFilteredTableList(tables);
        } else {
            let tableList = tables;
            if(tableList) setFilteredTableList(tableList.filter(t=>gameTypes[selectedGameType].includes(t.gameType)));
        }
    }

    const selectGameType = (option) => {
        setSelectedGameType(option);
        filterTables();
    } 

    useEffect(()=>{
        const clubId = isLeague ? gbClubId : currentClubId;
        if( !!clubPlayer && !!clubId && !pokerFrameLoaded && !!currentPokerFrame && (currentPokerFrame.status === parameters.pokerLobbyStates.NONE) ) {
            initPoker(clubId);
        }
    }, [currentClubId, isLeague, gbClubId, clubPlayer.username, currentPokerFrame]);

    useEffect(() => {
       filterTables();
    }, [selectedGameType, tables]);

    useEffect(() => {
        setTableListReady(isLeague || !!currentClubId);
        setFilteredTableList(tables);
    }, [currentClubId]);

    useEffect(() => {
        if (!!currentPokerFrame && currentPokerFrame.status === parameters.pokerLobbyStates.READY && pendingTableId) {
            openTable(pendingTableId);
        }
    }, [currentPokerFrame]);

    useEffect(() => {
      let interval = null;
      interval = setInterval(() => {
        setCurrentTime(new Date());
      }, 1000);
      return () => clearInterval(interval);
    }, [currentTime]);

    const openTable = tableId => {
        if (!!currentPokerFrame.wnd && currentPokerFrame.status === parameters.pokerLobbyStates.READY) {
            setPendingTableId('');
            currentPokerFrame.wnd.postMessage({ msg: 'openTable', tableId: tableId, role: roleInClub || 'player', isLeague: !!isLeague }, "*");
            if( isMobile ) {
                dispatch(alterPokerFrame(currentClubId, {isVisible: true}));
            }
        } else {
            setPendingTableId(tableId);
        }
    };

    const loadRenew = (e) => {
        e.preventDefault();
        // if (levelExpDays > 0) {
        history.push(`/club/${clubId}/createTable`);
        // } else {
        //     dispatch(openDialog('renewLevel', clubId));
        // }
    };

    return (
        <React.Fragment>
            <div className={`filter`}>
                {Object.keys(gameTypes).map(option => (
                    <span key={option} className={`option ${selectedGameType === option && 'selected'}`} onClick = {() => selectGameType(option)}>{option}</span>
                ))}
            </div>
            <div className={`pokerTables ${isLeague ? 'league' : ''}`}>
                {!isLeague && isAdminMember && config.createTable.enabled &&
                    <div className={`pokerTable createTable`} onClick={(e) => loadRenew(e)}></div>
                }
                {tableListReady && !!filteredTableList && filteredTableList.length > 0 &&
                    filteredTableList.map(table => (
                        <span key={table.tableId} onClick={() => openTable(table.tableId)}>
                            <PokerTable key={table.tableId} table={table} isLeague={isLeague} currentTime={currentTime} />
                        </span>
                    ))
                }
                { (!tables || !tables.length) && !isAdminMember &&
                    <EmptyList gameType={"poker"} roleInClub={roleInClub} />
                }
            </div>
        </React.Fragment>
    );
};

export default PokerTab;
